<h2 mat-dialog-title>Reenviar soportes</h2>

<mat-dialog-content>
  <p>
    ¿Desea reenviar los soportes al correo
    <strong>{{ data.correoEnmascarado }}</strong>?
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="confirmar()">Reenviar</button>
</mat-dialog-actions>